import React from 'react';
import PropTypes from 'prop-types';

/**
* Aplication button
* 
* @param {Object}   props
* @param {string}   props.type     - The button type (link, button, submit)
* @param {string}   props.text     - Main text
* @param {boolean}  props.noMargin - Sets if component has the default left margin
* @param {string}   props.mode     - Button style (primary, secondary, tertiary)
* @param {string}   props.css      - Custom css classes
* @param {string}   props.url      - Url rendered of a link type button. Component ignores the prop if type !== link
* @param {Function} props.onClick  - OnClick event handler
*/
const Button = ({ type, text, noMargin, mode, css, url, onClick }) => {
  const cssClassName = ['button', `button--${mode}`, css];
  noMargin && cssClassName.push('button--nomargin');

  const commomProperties = { className: cssClassName.join(' '), onClick: onClick };
  const button = <button type={type} {...commomProperties} >{text}</button>;
  const link = <a href={url} target='_blank' rel='noopener noreferrer' {...commomProperties} >{text}</a>;

  return (type === 'link' ? link : button);
}
Button.propTypes = {
  text: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  type: PropTypes.string,
  noMargin: PropTypes.bool,
  css: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func
};
export default Button